<template>
  <div class="Upload">
    <el-upload
      :drag="true"
      :limit="limitNum"
      :auto-upload="false"
      accept=".xlsx,.xls"
      :action="UploadUrl()"
      :before-upload="beforeUploadFile"
      :on-change="fileChange"
      :on-exceed="exceedFile"
      :on-success="handleSuccess"
      :on-error="handleError"
      :file-list="fileList"
      :on-remove="listRem"
      ref="clearFile"
      :show-file-list="false"
    >
      <div class="el-upload__text">
        <em style="color: #ffffff">点击上传</em>
      </div>
    </el-upload>
    <div class="el-upload__tip" slot="tip">
      <div class="document-name" style="color: #333333" v-if="fileList[0]">
        📋&nbsp;&nbsp;{{ fileList[0] ? fileList[0].name : "" }}
        <div class="icon_document">
          <i
            class="el-icon-error"
            style="color: #c1c1c1; cursor: pointer"
            @click="handelError"
          ></i>
        </div>
      </div>

      <span v-if="!fileList[0]" @click="exportToExcel" style="cursor: pointer"
        >&nbsp;&nbsp;模板下载</span
      >
    </div>
  </div>
</template>

<script>
import request from "../../../../../../../../../untils/request";
import { downloadTemp } from "../../../../../../../../assets/api/Agency/Enterprise";
export default {
  props: {
    url: {},
    type: {},
    Upload: {},
    Switch: {},
    ClearAll: {},
  },
  data() {
    return {
      limitNum: 1,
      fileList: [],
      currentFile: null,
      loading: false,
      uploadSeq: 0,
    };
  },
  watch: {
    ClearAll: {
      handler(newSs) {
        if (newSs == true) {
          this.hardReset(false);
        }
      },
      immediate: false,
    },
  },
  methods: {
    resetNativeInput() {
      try {
        const input =
          this.$refs.clearFile &&
          (this.$refs.clearFile.$refs.input ||
            this.$refs.clearFile.$el.querySelector('input[type="file"]'));
        if (input) input.value = "";
      } catch (e) {
        /* ignore */
      }
    },
    hardReset(emitClear) {
      this.uploadSeq += 1;
      this.currentFile = null;
      this.fileList = [];
      this.loading = false;
      if (this.$refs.clearFile) {
        this.$refs.clearFile.clearFiles();
      }
      this.resetNativeInput();
      this.$emit("upload-status", false);
      if (emitClear !== false) {
        this.$emit("handleClearOut");
      }
    },
    handelError() {
      this.hardReset(true);
    },
    exceedFile(files) {
      const raw = files && files[0];
      if (!raw) return;
      this.startUploadWithFile(raw);
    },
    fileChange(file, files) {
      if (file && file.status && file.status !== "ready") return;
      const latest = (files && files.length && files[files.length - 1]) || file;
      const raw = (latest && latest.raw) || (file && file.raw) || null;
      if (!raw) return;
      this.startUploadWithFile(raw);
    },
    listRem() {
      this.hardReset(true);
    },
    startUploadWithFile(raw) {
      if (!this.validateFile(raw)) {
        this.hardReset(false);
        return;
      }
      this.uploadSeq += 1;
      this.loading = false;
      this.currentFile = raw;
      this.fileList = [
        {
          name: raw.name,
          uid: Date.now() + "-" + Math.random(),
          raw,
          status: "ready",
        },
      ];
      this.resetNativeInput();
      this.$nextTick(() => {
        this.uploadFile();
      });
    },
    validateFile(file) {
      if (!file || !file.name) return false;
      const extension = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const size = file.size / 1024 / 1024;
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx、.xls的文件");
        return false;
      }
      if (size > 10) {
        this.$message.warning("文件大小不得超过10M");
        return false;
      }
      return true;
    },
    beforeUploadFile(file) {
      return this.validateFile(file);
    },
    handleSuccess() {},
    handleError() {},
    UploadUrl() {
      return "";
    },
    resetUpload() {
      this.hardReset(true);
    },
    uploadFile() {
      const targetFile = this.currentFile;
      if (!(targetFile instanceof Blob)) {
        this.$message.warning("请重新选择文件上传");
        this.hardReset(true);
        return;
      }
      const seq = ++this.uploadSeq;
      let form = new FormData();
      var data = {
        data: { headType: this.Switch },
      };
      const jsonBlob = new Blob([JSON.stringify(data)], {
        type: "application/json;charset=UTF-8",
      });
      form.append("apiRequest", jsonBlob, "apiRequest.json");
      form.append("file", targetFile, targetFile.name || "upload.xlsx");

      this.loading = true;
      this.$emit("upload-status", true);
      request({
        method: "post",
        url: this.url,
        data: form,
      })
        .then((res) => {
          if (seq !== this.uploadSeq) return;
          if (res && res.data && res.data.code == 0) {
            try {
              const payload = res.data.data;
              if (Array.isArray(payload) && payload.length === 0) {
                this.$tool.PromptBox("error", "上传文件解析为空请重新上传");
                this.$emit("handleClearOut");
                return;
              }
              this.$emit("handleOkImport", res);
            } catch (e) {
              console.error(e);
              this.hardReset(true);
            } finally {
              if (seq === this.uploadSeq) {
                this.loading = false;
                this.$emit("upload-status", false);
              }
            }
          } else {
            this.loading = false;
            this.$emit("upload-status", false);
            this.$emit("handleClearOut");
          }
        })
        .catch(() => {
          if (seq !== this.uploadSeq) return;
          this.loading = false;
          this.$emit("upload-status", false);
          this.$emit("handleClearOut");
        });
    },
    exportToExcel() {
      this.loading = true;
      var data = {
        data: {
          type: this.type,
        },
      };
      downloadTemp(data).then((res) => {
        const link = document.createElement("a");
        let blob = new Blob([res], {
          type: "application/vnd.ms-excel;charset=UTF-8",
        });
        var encodedStr = sessionStorage.getItem("headersC");
        var index = encodedStr.lastIndexOf("''");
        var aa = encodedStr.substring(index + 2);
        const chineseText = decodeURIComponent(aa);
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", chineseText);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.loading = false;
      });
    },
    handleClose() {
      if (!this.loading) {
        this.$emit("handleClose");
        this.hardReset(false);
      }
    },
  },
};
</script>

<style scoped lang="less">
.Upload {
  width: 100%;
  display: flex;
  height: 35px;
  /deep/.el-upload-dragger {
    width: 110px !important;
    height: 33px !important;
    line-height: 33px;
    background: #409eff;
    border: 1px solid #409eff;
  }
  .el-upload__tip {
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    color: #409eff;
    margin: auto;
    margin-left: 20px;
    .document-name {
      padding: 0px 5px;
      border-radius: 5px;
      background-color: rgba(150, 150, 150, 0.2);
      position: relative;
      .icon_document {
        position: absolute;
        top: -15px;
        right: -8px;
        font-size: 20px;
      }
    }
  }
}
</style>
